import { Flex, Spinner } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';

import { useUserStore } from '@store/app.store';
import { useStyledToast } from '@util/hooks';

function LogoutPage() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const toast = useStyledToast();
  const userStore = useUserStore();

  useEffect(() => {
    const logout = async () => {
      try {
        await userStore.logout();
        queryClient.removeQueries();
        navigate('/login');
        toast({
          title: 'Logout Successful',
          isClosable: true,
          duration: 4000
        });
      } catch (e) {
        Sentry.withScope((scope) => {
          scope.setTag('error_type', 'logout_error');
          scope.setExtra('error_message', 'Error during logout');
          Sentry.captureException(e);
        });
        toast({
          title: 'Error during logout',
          status: 'error',
          isClosable: true,
          duration: 4000
        });
      }
    };
    logout();
  }, []);

  return (
    <Flex
      data-cy='logout-page'
      h='full'
      alignItems='center'
      flexDir='column'
      pt={16}
      gap={6}
    >
      <Spinner />
      <div>Logging out...</div>
    </Flex>
  );
}

export default LogoutPage;
